import React, { useState } from "react";
import SectionLoader from "components/ui/loaders/SectionLoader";
import SelectDropDown from "components/ui/forms/SelectDropDown";
import { useAuth } from "provider/AuthContext";
import Auth from "service/AuthService";
import { API_URL } from "helper/Constants";

export const roleQueryParams = {
  Partner: "partnerId",
  SuperAgent: "superAgentId",
  Agent: "agentId",
  User: "playerId",
};

const RoleBasedDropdowns = ({
  userLoading,
  showSelectRole,
  baseRole,
  setBaseRole,
  selectedRole,
  setSelectedRole,
  selectedInputValues,
  setSelectedInputValues,
}) => {
  // const selectRef = useRef(null);
  const { user } = useAuth();
  const authServ = new Auth(API_URL);

  const [inputValues, setInputValues] = useState({});
  const [suggestionMenuStates, setSuggestionMenuStates] = useState({});

  const hierarchy = ["Owner", "Partner", "SuperAgent", "Agent", "User"];
  const userRoleIndex = hierarchy.indexOf(user?.role);
  const filteredHierarchy = hierarchy.filter((role) => hierarchy.indexOf(role) > userRoleIndex);

  const handleChange = (option, currentRole) => {
    const normalizedRole = hierarchy.find((item) => item.toLowerCase() === option.value.toLowerCase());
    const currentIndex = hierarchy.indexOf(normalizedRole);
    setBaseRole(normalizedRole); // Set the base role
    setSelectedRole((prevValues) => {
      const updatedValues = { ...prevValues, [currentRole]: option.value };
      hierarchy.slice(currentIndex + 1).forEach((lowerLevel) => {
        updatedValues[lowerLevel] = null;
      });
      return updatedValues;
    });
  };
  //console.log(selectedInputValues, "selectedInputValues");

  const baseRoleIndex = hierarchy.indexOf(baseRole);
  let rolesToRender = [];
  if (showSelectRole) {
    rolesToRender = baseRole !== null ? filteredHierarchy.slice(0, filteredHierarchy.indexOf(baseRole) + 1) : [];
  } else {
    rolesToRender = baseRoleIndex !== -1 ? hierarchy.slice(baseRoleIndex + 1) : [];
  }
  const handleInputChange = (value, role) => {
    setInputValues((prev) => ({
      ...prev,
      [role]: value,
    }));
    if (value.length >= 3) {
      setSuggestionMenuStates((prev) => ({
        ...prev,
        [role]: true,
      }));
    } else {
      setSuggestionMenuStates((prev) => ({
        ...prev,
        [role]: false,
      }));
    }
  };
  const handleMenuClose = (role) => {
    setSuggestionMenuStates((prev) => ({
      ...prev,
      [role]: false,
    }));
  };

  const fetchAllUsers = async (inputValue, callback, role) => {
    if (inputValue.length < 3) {
      callback([]);
      return;
    }
    try {
      let response;
      let options = [];
      if (user?.role === "Owner") {
        response = await authServ.getAllUsers();
        // setAllUsers(response.users);
        options = response.users
          .filter((fi) => fi.username !== user.username && fi.role === role && fi.username.toLowerCase().includes(inputValue.toLowerCase()))
          .map((item) => ({
            value: item._id,
            label: item.username,
          }));
      } else {
        response = await authServ.getUsersByCreatorId(user._id);
        options = response.users.children
          .filter((fi) => fi.username !== user.username && fi.role === role && fi.username.toLowerCase().includes(inputValue.toLowerCase()))
          .map((item) => ({
            value: item._id,
            label: item.username,
          }));
        // setAllUsers(response.users?.children);
      }
      //console.log("API response:", response);
      callback(options);
    } catch (error) {
      console.error("Error fetching users:", error);
      callback([]);
    }
  };

  if (userLoading) {
    return (
      <div className="text-center w-full">
        <SectionLoader bgColor="light" />
      </div>
    );
  }

  return (
    <>
      <div className="w-full lg:flex gap-3">
        {showSelectRole && (
          <div className="relative mb-4 w-full lg:min-w-[400px] lg:max-w-[400px]">
            <SelectDropDown
              label="Role"
              placeholder="Select option"
              selectedOption={selectedRole ? selectedRole["role"]?.value : []}
              options={filteredHierarchy.map((role) => ({
                value: role,
                label: role === "SuperAgent" ? "Super Agent" : role,
              }))}
              handleChange={(option) => handleChange(option, "role")}
            />
          </div>
        )}
        {rolesToRender.map((role) => (
          <div key={role} className="relative mb-4 w-full lg:max-w-80">
            <SelectDropDown
              label={role}
              placeholder={"Type 3+ letters"}
              selectedOption={selectedRole ? selectedRole[role]?.value : []}
              loadOptions={(inputValue, callback) => fetchAllUsers(inputValue, callback, role)}
              handleChange={(option) =>
                setSelectedInputValues((prev) => ({
                  ...prev,
                  [role]: option.value, // Assign value to the specific role
                }))
              }
              inputValue={inputValues[role] || ""}
              onInputChange={(value) => handleInputChange(value, role)}
              menuIsOpen={suggestionMenuStates[role] || false}
              onMenuClose={() => handleMenuClose(role)}
              isSearchable={true}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default RoleBasedDropdowns;
